import { breakpoint, Column, Row } from '../grid';
import { kievitSlabBook, sharpSansBold } from '../typography';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import { FormattedMessage } from 'react-intl';
import LocalizedStrings from './LocalizedStrings';
import { navy } from '@zocdoc/branding/colors';
import styled from 'styled-components';
import Zee404 from './Zee404.png';
import Zee500 from './Zee500.png';

const ErrorRow = styled(Row)`
    box-sizing: border-box;
    padding-bottom: 32px;
    padding-top: 32px;

    ${breakpoint.xsmall} {
        padding-bottom: 80px;
        padding-top: 80px;
    }
`;

const LeftColumn = styled(Column)`
    ${breakpoint.small} {
        float: left;
    }
`;

const RightColumn = styled(Column)`
    ${breakpoint.small} {
        float: right;
    }
`;

const Zee = styled.div`
    background-image: url(${p => p.statusCode === 404 ? Zee404 : Zee500});
    background-repeat: round;
    display: block;
    float: none;
    height: 240px;
    margin-left: auto;
    margin-right: auto;
    width: 240px;

    ${breakpoint.small} {
        display: inline-block;
        float: left;
    }
`;

const Header = styled.h1`
    ${sharpSansBold(28, 28)};
    color: ${navy};
    margin-top: 32px;
`;

const Text = styled.p`
    ${kievitSlabBook(14, 20)};
    color: ${navy};
    margin-bottom: 24px;
    margin-top: 24px;
`;

export const ReturnButton = styled(Button)`
    box-sizing: border-box;
    width: 100%;

    ${breakpoint.small} {
        width: initial;
    }
`;

const ErrorPage = ({ statusCode }) => {
    const header = statusCode === 404 ? LocalizedStrings.Header404 : LocalizedStrings.Header500;
    const text = statusCode === 404 ? LocalizedStrings.Text404 : LocalizedStrings.Text500;

    return (
        <ErrorRow data-status-code={statusCode}>
            <RightColumn
                end
                offset={1}
                size={{
                    xxsmall: 22,
                    small: 10,
                }}
            >
                <Zee statusCode={statusCode} />
            </RightColumn>
            <LeftColumn
                end
                offset={1}
                size={{
                    xxsmall: 22,
                    small: 11,
                }}
            >
                <Header>
                    <FormattedMessage {...header} />
                </Header>
                <Text>
                    <FormattedMessage {...text} />
                </Text>
                <ReturnButton href="/">
                    <FormattedMessage {...LocalizedStrings.ReturnHome} />
                </ReturnButton>
            </LeftColumn>
        </ErrorRow>
    );
};

ErrorPage.propTypes = {
    statusCode: PropTypes.number.isRequired,
};

export {
    ErrorPage as default,
    ErrorPage,
};
